import { FLAG_ID_ENABLE_GRID_STATE_SERVICE_TELEMETRY } from "./constants";
import { ConfigSettingsUtil } from "../util/ConfigSettingsUtil";
var logger;
var isInitialized = false;
var telemetryLogger;
// verify logger at invocation to provide default to log errors without cuff
var loggerWithDefault = {
    error: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (logger ? logger.error.apply(logger, args) : console.error.apply(console, args));
    },
    log: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (logger ? logger.log.apply(logger, args) : console.log.apply(console, args));
    },
    logClientEvent: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (logger ? logger.logClientEvent.apply(logger, args) : console.log.apply(console, args));
    },
    logEventWithoutPrivateInfo: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (logger ? logger.logEventWithoutPrivateInfo.apply(logger, args) : console.log.apply(console, args));
    },
    logTelemetryWithoutPrivateInfo: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return telemetryLogger ? telemetryLogger.logTelemetryWithoutPrivateInfo.apply(telemetryLogger, args) : console.log.apply(console, args);
    },
    warn: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (logger ? logger.warn.apply(logger, args) : console.warn.apply(console, args));
    }
};
export var initializeLoggingService = function (loggerInstance) {
    if (!isInitialized) {
        logger = loggerInstance;
        telemetryLogger = new (/** @class */ (function () {
            function class_1() {
            }
            class_1.prototype.logTelemetryWithoutPrivateInfo = function (objectID, actionID, parm1String, parm1Int, eventMetadata) {
                var isTelemetryEnabled = ConfigSettingsUtil.isConfigSettingBooleanTrue(FLAG_ID_ENABLE_GRID_STATE_SERVICE_TELEMETRY);
                if (isTelemetryEnabled) {
                    logger.logEventWithoutPrivateInfo(objectID, actionID, parm1String, parm1Int, eventMetadata);
                }
            };
            return class_1;
        }()))();
        isInitialized = true;
    }
    else {
        console.debug("Duplicate logger requested, only one instance of LoggingStateService needed.");
    }
};
export default loggerWithDefault;
//# sourceMappingURL=Logger.js.map